import { useEffect, useState } from 'react'

import { INTAKE_LOCK_EVENT, isIntakeLockActive } from './intake-lock'

// Reactively tracks whether an intake block is active for the current user.
// Re-syncs on same-tab lock changes (custom event) and cross-tab changes
// (native `storage` event), so the global gate appears/disappears immediately.
export const useIntakeLock = (): boolean => {
  const [locked, setLocked] = useState<boolean>(() => isIntakeLockActive())

  useEffect(() => {
    const sync = () => setLocked(isIntakeLockActive())
    sync()
    window.addEventListener(INTAKE_LOCK_EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(INTAKE_LOCK_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  return locked
}
